module.exports = __webpack_public_path__ + "img/714.e1515b4f.png";